import { useTranslation } from 'react-i18next';

import React from 'react';

import { useCommunityContext } from 'components/CommunityContext';
import { NotificationPane } from 'components/NotificationPane';
import UserAvatar from 'components/UserAvatar';

import { BaseGlobalHeader } from './GlobalHeader';

const DirectMessagingGlobalHeader = ({ title }: { title?: string }) => {
  const { t } = useTranslation();
  const { currentUser } = useCommunityContext();

  return (
    <BaseGlobalHeader
      rightContent={
        <>
          <NotificationPane />
          <UserAvatar
            size="xs"
            {...currentUser}
            userId={currentUser.id}
            username={currentUser.fullName}
            shouldOpenSideMenu
          />
        </>
      }
      title={title || t('pages-direct_messages_title', 'Direct Messages')}
    />
  );
};

export default DirectMessagingGlobalHeader;
